import { database } from '../../firebase';
import { createAction, handleActions } from 'redux-actions';

export enum DONATIONS_ACTION_TYPES {
  REQUEST_INSERT_CHARITIES = '@DONACO/REQUEST_INSERT_CHARITIES',
  FETCH_ALL_DONATIONS_SUCCEEDED = '@DONACO/FETCH_ALL_DONATIONS_SUCCEEDED',
  REQUEST_UPDATE_ITEM_DONATIONS = '@DONACO/REQUEST_UPDATE_ITEM_DONATIONS'
}

const defaultState = {
  all: null
};

export const startListeningForDonations = createAction(
  DONATIONS_ACTION_TYPES.REQUEST_INSERT_CHARITIES
);
export const fetchAllDonationsSuccess = createAction(
  DONATIONS_ACTION_TYPES.FETCH_ALL_DONATIONS_SUCCEEDED,
  (payload: any) => payload
);

export const donationsReducer = handleActions(
  {
    [DONATIONS_ACTION_TYPES.FETCH_ALL_DONATIONS_SUCCEEDED]:
    (
      state,
    { payload } 
    ) => {
      const donationsState = {
        ...state,
        all: payload
    }
    return donationsState
    },
    [DONATIONS_ACTION_TYPES.REQUEST_UPDATE_ITEM_DONATIONS]:  
    (
      state,
    { payload }
    ) => {
      
      if(payload.id === 0){
        state = state.all.filter(function( obj ) {
          return obj.id !== payload.id;
        });
      } else {
        state.all[payload.id] = {
          ...state.all[payload.id],
          amount: payload.amount
        }
      }
      
      return {
        ...state
      }
    }
  },
  defaultState
);